<div class="row card">
    <div class="image-wrapper">
        <img width="256" height="256" priority placeholder ngSrc="/assets/about-me/idris-esen.png" i18n-alt alt="Idris Esen" />
    </div>
    <div class="content">
        <h3 class="title" i18n="Idris Esen">Idris Esen</h3>
        <p i18n>
            Born in 1975 in the culturally rich land of Syria, I embarked on my artistic journey at the Faculty of Fine Arts, Damascus, graduating in 1998. My creative odyssey
            encompasses three profound realms:
        </p>
    </div>
</div>
<div class="row card">
    <div class="image-wrapper">
        <img width="256" height="256" priority placeholder ngSrc="/assets/category/paint.jpg" alt="Paint Art" />
    </div>
    <div class="content">
        <h3 class="title" i18n="Paint Art">Paint Art</h3>
        <p>
            <span i18n>My brushstrokes have narrated tales in three solo exhibitions across Turkey:</span><br />
            <span i18n>- 2005: Sanko Art Gallery, Gaziantep</span><br />
            <span i18n>- 2007: Sanko Art Gallery, Gaziantep</span><br />
            <span i18n>- 2009: İsmet Paşa Art Gallery, Ankara</span><br />
        </p>
        <a class="button button-primary" routerLink="/gallery/paint/"><span i18n="Explore My Paint Portfolio">Explore My Paint Portfolio</span></a>
    </div>
</div>
<div class="row card">
    <div class="image-wrapper">
        <img width="256" height="256" priority placeholder ngSrc="/assets/category/photography-art.jpg" alt="Photography" />
    </div>
    <div class="content">
        <h3 class="title" i18n="Photography">Photography</h3>
        <p i18n>
            Through my lens, I have captured the essence of fashion, industry, and life itself. My photography projects, executed with cutting-edge technology, have brought visions
            to life in vivid detail.
        </p>
        <a class="button button-primary" routerLink="/gallery/photography-art"><span i18n="Discover My Photography Portfolio">Discover My Photography Portfolio</span></a>
    </div>
</div>
<div class="row card">
    <div class="image-wrapper">
        <img width="256" height="256" priority placeholder ngSrc="/assets/category/graphic-design.jpg" alt="Graphic Design" />
    </div>
    <div class="content">
        <h3 class="title" i18n="Graphic Design">Graphic Design</h3>
        <p i18n>
            In the realm of graphic design, I have woven visual narratives for esteemed clients, from crafting characters for the film "Bilal" by Parajon Production to
            storyboarding commercials for Saudi Arabian Airlines. My last artistic venture was leading the graphic design department at Merinos Carpet Company.
        </p>
        <a class="button button-primary" routerLink="/gallery/graphic-design"><span i18n="View My Graphic Design Portfolio">View My Graphic Design Portfolio</span></a>
    </div>
</div>
